
class HXFormFieldEmail extends HXFormField {

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * Icon aktiv/inaktiv anzeigen, abh. von gueltiger Url im Feld
     * wird intern aufgerufen
     */
    enableEmailOpenIcon() {
        let openIcon = $('.js-email_icon-'+this.inputName+'');
        openIcon.removeClass('hx-fa-icon-form-on').removeClass('hx-fa-icon-form-off');
        if (hx.isValidEmailAddress(this.getValue()) === true) {
            openIcon.addClass('hx-fa-icon-form-on');
        } else {
            openIcon.addClass('hx-fa-icon-form-off');
        }
    }

    /**
     * Wert setzen und Status des Icons aktualisieren
     * @param {string|int} value
     */
    setValue(value){
        super.setValue(value);
        this.enableEmailOpenIcon();
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            var value = ''+this.getValue();

            if (!this.getOptional() && value === '') {
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;
            } else if(value !== '' && !hx.isValidEmailAddress(value)) {
                this.validationMsg = hx.replace(this.formVars.dictFormatMsg, "#name#", this.getLabel());
                this.validationPassed = false;
            }
            if (alertResult===true) super._validateFieldAlert();

        }
        return this.validationPassed;
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'text');
    }

    /**
     * Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true) {
            this.enableEmailOpenIcon();

            document.getElementsByClassName('js-email_icon-' + this.inputName)[0].addEventListener("click", (event) => {  //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                event.preventDefault();
                if (hx.isValidEmailAddress(this.getValue())) window.open('mailto:' + this.getValue());
            });

            if (this.getEditable()) {
                this.inputObj.addEventListener("keyup", (event) => { //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                    this.enableEmailOpenIcon();
                });
            }
        }
    }
}




